import { Container, Row } from "reactstrap";
import AdditionalAlert from "./AdditionalAlert";
import AlertWithIcons from "./AlertWithIcons";
import DismissingDarkAlert from "./DismissingDarkAlert";
import DismissingLightAlert from "./DismissingLightAlert";
import LeftBorderAlert from "./LeftBorderAlert";
import { Breadcrumbs } from "../../../AbstractElements";
import { Alert, LinkColorTitle, LinkLightColorTitle, UiKits } from "../../../Constants/Constants";
import LiveAlert from "./LiveAlert";
import OutlineAlert from "./OutlineAlert";
import CommonLinkColor from "./CommonLinkColor";
import { AlertColorData, AlertLightColorData } from "../../../Data/UiKits/Alert";

const AlertContainer = () => {
  return (
    <>
    <Breadcrumbs mainTitle={Alert} parent={UiKits}/>
    <Container fluid>
      <Row>
        <CommonLinkColor title={LinkColorTitle} data={AlertColorData}/>
        <CommonLinkColor title={LinkLightColorTitle} data={AlertLightColorData}/>
        <OutlineAlert />
        <AlertWithIcons />
        <DismissingDarkAlert />
        <DismissingLightAlert />
        <LiveAlert />
        <LeftBorderAlert />
        <AdditionalAlert />
      </Row>
    </Container>
    </>
  );
};
export default AlertContainer;
